module.exports = __webpack_public_path__ + "img/contact-picture.142c4c95.jpg";